export default __webpack_public_path__ + "static/media/googlePlay.55ad3f1f.png";